<div class="ec-bg" [style.background]="background"></div>
<div class="ec-circle"></div>

<div class="ec-hero" *ngIf="heroUrl">
  <div class="ec-hero-glow"></div>
  <img class="ec-hero-img" [src]="heroUrl" alt="" />
</div>

<div class="ec-scrim" [style.background]="scrimGradient"></div>

<img *ngIf="logoUrl" class="ec-logo" [src]="logoUrl" alt="" />

<div class="ec-content">
  <app-reel-marquee class="ec-marquee" [items]="catalog"></app-reel-marquee>

  <div class="ec-eyebrow">{{ 'reel.beforeYouGo' | translate | uppercase }}</div>
  <div class="ec-title" *ngIf="hasTitle">{{ title }}</div>
  <div class="ec-desc" *ngIf="hasDescription">{{ description }}</div>

  <div class="ec-buttons">
    <button type="button" class="ec-btn ec-btn-filled" (click)="watchAgain.emit()">
      <svg class="ec-btn-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 6V3L8 7l4 4V8a4 4 0 1 1-3.86 5h-2.04A6 6 0 1 0 12 6Z" />
      </svg>
      <span>{{ watchAgainLabel }}</span>
    </button>
    <button type="button" class="ec-btn ec-btn-outline" (click)="close.emit()">
      <span>{{ closeLabel }}</span>
    </button>
  </div>
</div>
